export default {
  cn: {
    changePassword: {
      loginId: '登录账号',
      oldPwd: '旧密码',
      newPwd: '新密码',
      confirmPwd: '确认密码',
      saveBtn: '保存',
      errTips: {
        newPwd: '请输入新密码',
        confirmPwd: '两次输入不一致'
      },
      success: '保存成功',
    }
  },
  hk: {
    changePassword: {
      loginId: '登錄賬號',
      oldPwd: '舊密碼',
      newPwd: '新密碼',
      confirmPwd: '確認密碼',
      saveBtn: '保存',
      errTips: {
        newPwd: '請輸入新密碼',
        confirmPwd: '兩次輸入不一致'
      },
      success: '保存成功',
    }
  },
  en: {
    changePassword: {
      loginId: 'Login ID',
      oldPwd: 'Old Password',
      newPwd: 'New Password',
      confirmPwd: 'Confirm Password',
      saveBtn: 'SAVE',
      errTips: {
        newPwd: 'Please enter new password',
        confirmPwd: "The two inputs don't agree"
      },
      success: 'successfully',
    }
  },
}


// WEBPACK FOOTER //
// ./src/language/changePassword.js